module.exports = __webpack_public_path__ + "img/t1.7868b0c8.png";